export default (match, key) => {
    return <a style={{fontStyle: "italic",color: "blue"}} href={'//'+match} key={key} target="_blank">{match}</a>
}